export const isClient = () => typeof window === "object"
export const clientOnly = (func: Function) =>
  isClient() ? func : () => undefined
